import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useTranslation } from 'react-i18next';

const slide = keyframes`
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

const Bar = styled.div`
  background: ${({ theme }) => theme.colors.blue};
  padding: 13px 0;
  overflow: hidden;
  position: relative;
  z-index: 1;
`;

const Track = styled.div`
  display: flex;
  gap: 56px;
  animation: ${slide} 22s linear infinite;
  white-space: nowrap;
  width: max-content;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  font-family: ${({ theme }) => theme.fonts.display};
  font-size: 17px;
  letter-spacing: 0.14em;
  color: rgba(0, 0, 30, 0.75);
  flex-shrink: 0;
`;

const Dot = styled.span`
  width: 5px; height: 5px;
  background: rgba(0,0,30,0.35);
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
`;

export default function Marquee() {
  const { t } = useTranslation();
  const items = t('marquee.items', { returnObjects: true });
  const doubled = [...items, ...items];

  return (
    <Bar>
      <Track>
        {doubled.map((item, i) => (
          <Item key={i}>
            <Dot />
            {item}
          </Item>
        ))}
      </Track>
    </Bar>
  );
}
